import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { config } from '../../../../config/config';
import { selectLocale } from '../../../shared/store/locale.store';
import { InGameSearch } from '../../components/ingame-search/ingame-search';
import { useGetGameSearchQuery } from '../../queries/search.graphql';

export interface IInGameSearchProps {
    onSelectGame?: (slug: string) => void;
    currentVendors: string[];
    currentGames: string[];
}

export const InGameSearchContainer: FunctionComponent<IInGameSearchProps> = ({
    onSelectGame,
    currentVendors,
    currentGames,
}) => {
    const [query, setQuery] = useState('');
    const locale = useSelector(selectLocale);
    const [{ fetching, data }] = useGetGameSearchQuery({
        variables: {
            xTenantID: config.TENANT_ID,
            searchTerm: query,
            skinId: config.SKIN_ID,
            locale,
        },
    });

    const games = fetching
        ? []
        : data?.getGameSearch.filter(
              (game): game is Exclude<typeof game, null | undefined> =>
                  !!game &&
                  !currentGames.includes(game.id) &&
                  (game.gameVendor.multiplayEnabled ||
                      !currentVendors.includes(game.gameVendor.id)),
          );

    return (
        <InGameSearch
            onSelectGame={onSelectGame}
            onQueryChange={(newQuery) => setQuery(newQuery)}
            games={games ?? []}
            query={query}
        />
    );
};
